export const predefinedScreens = [
  {
    id: 'overbought-us',
    name: 'Overbought (US)',
    filters: {
      rsiMoreThan: 70,
      exchange: ['NASDAQ', 'NYSE', 'AMEX']
    }
  },
  {
    id: 'oversold-us', 
    name: 'Oversold (US)',
    filters: {
      rsiLowerThan: 30,
      exchange: ['NASDAQ', 'NYSE', 'AMEX']
    }
  },
  {
    id: 'undervalued-large-caps',
    name: 'Undervalued Large Caps (US)',
    filters: {
      dcfDiffMoreThan: 20,
      marketCapMoreThan: 1000000000,
      peLowerThan: 15,
      exchange: ['NASDAQ', 'NYSE', 'AMEX']
    }
  },
  {
    id: 'deep-value',
    name: 'Deep Value (US)',
    filters: {
      dcfDiffMoreThan: 50,
      peLowerThan: 10,
      priceLowerThan: 20,
      exchange: ['NASDAQ', 'NYSE', 'AMEX']
    }
  },
  {
    id: 'quality-value',
    name: 'Quality Value (US)',
    filters: {
      dcfDiffMoreThan: 15,
      betaLowerThan: 1.2,
      marketCapMoreThan: 500000000,
      peLowerThan: 20,
      exchange: ['NASDAQ', 'NYSE', 'AMEX']
    }
  },
  {
    id: 'low-volatility',
    name: 'Low Volatility (US)',
    filters: {
      betaLowerThan: 0.8,
      marketCapMoreThan: 1000000000,
      rsiMoreThan: 30,
      rsiLowerThan: 70,
      exchange: ['NASDAQ', 'NYSE', 'AMEX']
    }
  },
  {
    id: 'high-beta-momentum',
    name: 'High Beta Momentum (US)',
    filters: {
      betaMoreThan: 1.5,
      rsiMoreThan: 60,
      marketCapMoreThan: 100000000,
      exchange: ['NASDAQ', 'NYSE', 'AMEX']
    }
  },
  {
    id: 'large-cap-leaders',
    name: 'Large Cap Leaders (US)',
    filters: {
      marketCapMoreThan: 10000000000,
      averageType: '200',
      comparisonType: 'above',
      minPercentage: '0',
      exchange: ['NASDAQ', 'NYSE', 'AMEX']
    }
  },
  {
    id: 'mid-cap-opportunities',
    name: 'Mid Cap Opportunities (US)',
    filters: {
      marketCapMoreThan: 2000000000,
      marketCapLowerThan: 10000000000,
      dcfDiffMoreThan: 10,
      peLowerThan: 25,
      exchange: ['NASDAQ', 'NYSE', 'AMEX']
    }
  },
  {
    id: 'tech-value',
    name: 'Tech Value Play (US)',
    filters: {
      sector: 'Technology',
      dcfDiffMoreThan: 15,
      peLowerThan: 30,
      marketCapMoreThan: 1000000000,
      exchange: ['NASDAQ', 'NYSE', 'AMEX']
    }
  },
  {
    id: 'defensive-dividend',
    name: 'Defensive Plays (US)',
    filters: {
      sector: 'Utilities',
      betaLowerThan: 1,
      marketCapMoreThan: 1000000000,
      exchange: ['NASDAQ', 'NYSE', 'AMEX']
    }
  }
];